import angular from 'angular';
import template from './downgrade-to-audio-only-frame.html';
import { DATA_URL_IMAGE_PREFIX } from '../../../../modules/core/constants';
class Controller {
    constructor(downgradeCallStateService, VideoProviderFactory, pn) {
        this.downgradeCallStateService = downgradeCallStateService;
        this.VideoProviderFactory = VideoProviderFactory;
        this.pn = pn;
        this.applyFilter = true;
    }
    turnOnVideo() {
        this.VideoProviderFactory.activeProvider.togglePublishersVideo(true);
        this.downgradeCallStateService.turnOnVideo();
    }
    hearingInfoLabel() {
        return this.VideoProviderFactory.activeProvider.ui.hasAudio
            ? 'video-chat.downgrade-to-audio-only.bottom-notification'
            : `video-chat.downgrade-to-audio-only.bottom-notification-mic-off${this.isPatient ? '-patient' : ''}`;
    }
    isShownImprovedMessage() {
        const amIDoctor = this.pn.isDoctor();
        return this.downgradeCallStateService.isImproved() && amIDoctor;
    }
    hasUploadedAvatar() {
        return (this.avatarPicture &&
            !this.avatarPicture.startsWith(DATA_URL_IMAGE_PREFIX));
    }
}
const downgradeToAudioOnlyFrameComponent = {
    template,
    bindings: {
        avatarPicture: '<',
        screen: '<',
        username: '<',
        isPatient: '<',
    },
    controller: Controller,
};
export default angular
    .module('doxy.videoChat.callFrames.downgradeToAudioOnlyFrame', [])
    .component('downgradeToAudioOnlyFrame', downgradeToAudioOnlyFrameComponent)
    .name;
